import CourseBookingPage from "./courseBookingPage"
export default CourseBookingPage;